import React from "react";

import { Stack } from "@mui/material";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TransitionHeader.module.css";

interface TransitionHeaderProps {
  title: string;
  subtitle?: string;
  rightContent?: React.ReactNode;
}

const TransitionHeader: React.FC<TransitionHeaderProps> = ({
  title,
  subtitle,
  rightContent,
}) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      spacing={2}
      className={styles.headerStack}
    >
      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Text variant="title3" color="text">
          {title}
        </Text>
        {subtitle && (
          <Text variant="body" color="textSubtle">
            {subtitle}
          </Text>
        )}
      </Stack>
      {rightContent}
    </Stack>
  );
};

export default TransitionHeader;
